import { Observable } from 'rxjs';
import {
  SimulationRequest,
  SimulationResult,
} from '../models/site-simulation.model';

/**
 * An abstract class doubling as the DI token and the contract, so replacing the client-side
 * mock engine with a real endpoint is a change of binding only.
 */
export abstract class SiteSimulationRepository {
  /** Run a simulation for the given three-point / single-value parameters. */
  abstract runSimulation(
    request: SimulationRequest,
  ): Observable<SimulationResult>;
}
